import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { SettingsComponent } from './settings.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { EmailNotificationsComponent } from './email-notifications/email-notifications.component';
import { NotificationApproversComponent } from './notification-approvers/notification-approvers.component';
import { AgentsInFieldComponent } from './agents-in-field/agents-in-field.component';
import { TimeConfigurationComponent } from './time-configuration/time-configuration.component';
import { AgentDispatchConfigurationComponent } from './agent-dispatch-configuration/agent-dispatch-configuration.component';

const routes: Routes = [
    {
      path: '',
      canActivate: [AuthGuard],
        children: [
            {
              path: '',
              component: SettingsComponent,
              canActivate: [AuthGuard],
              children: [
                {
                  path: '',
                  component: SettingsComponent,
                  canActivate: [AuthGuard]

                },
                {
                  path: 'email-notifications',
                  children: [{
                    path: '',
                    component: EmailNotificationsComponent,
                    canActivate: [AuthGuard]
                  }]
                },
                
                {
                  path: 'preconfigured-messages',
                  loadChildren: () => import('src/app/main/settings/preconfigured-messages/preconfigured-messages.module').then(m => m.PreconfiguredMessagesModule),
                  canActivate: [AuthGuard]
                },
                {
                  path: 'rejection-messages',
                  loadChildren: () => import('src/app/main/settings/rejection-messages/rejection-messages.module').then(m => m.RejectionMessagesModule),
                  canActivate: [AuthGuard]
                },
                {
                  path: 'group-management',
                  loadChildren: () => import('src/app/main/settings/group-management/group-management.module').then(m => m.GroupManagementModule),
                  canActivate: [AuthGuard]
                },
                {
                  path: 'time-configuration',
                  component: TimeConfigurationComponent,
                  canActivate: [AuthGuard]
                },
                {
                  path: 'agent-dispatch-configuration',
                  component: AgentDispatchConfigurationComponent,
                  canActivate: [AuthGuard]
                },
                {
                  path: 'agents-in-field',
                  component: AgentsInFieldComponent,
                  canActivate: [AuthGuard]
                },
                {
                  path: 'geo-zones',
                  loadChildren: () => import('src/app/main/settings/geo-zones/geo-zones.module').then(m => m.GeoZonesModule),
                  canActivate: [AuthGuard]
                },
                {
                  path: 'notification-approvers',
                  component: NotificationApproversComponent,
                  canActivate: [AuthGuard]
                },
                // {
                //   path: 'custom-alerts',
                //   loadChildren: () => import('src/app/main/settings/custom-alerts/custom-alerts.module').then(m => m.CustomAlertsModule),
                //   canActivate: [AuthGuard]
                // },
                {
                  path: 'custom-fields',
                  loadChildren: () => import('src/app/main/settings/custom-fields/custom-fields.module').then(m => m.CustomFieldsModule),
                  canActivate: [AuthGuard]
                },
              ]
            },
        ]
    }
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class SettingsRoutingModule {}